import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import {
    IItemsListFilter,
    ISelectedFilterItem,
} from '@fi-shared/fi-items-list/fi-items-list-filter/fi-items-list-filter/fi-items-list-filter';
import { FiFilterType } from '@fi-shared/fi-items-list/fi-items-list-filter/fi-filter-type-enum';

@Component({
    selector: 'fi-items-list-edit-filter-dialog',
    templateUrl: './fi-items-list-edit-filter-dialog.component.html',
    styleUrls: ['./fi-items-list-edit-filter-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-items-list-edit-filter-dialog' },
    standalone: false,
})
export class FiItemsListEditFilterDialogComponent extends FiDialogsContentBase<
    ISelectedFilterItem[],
    ISelectedFilterItem[]
> {
    get selectedFilterItems() {
        return this.data;
    }

    removeSelectedFilterItem(item: ISelectedFilterItem) {
        const selectedFilterItemIndex = this.selectedFilterItems.indexOf(item);
        this.selectedFilterItems.splice(selectedFilterItemIndex, 1);
    }

    getResult(): ISelectedFilterItem[] {
        return this.selectedFilterItems;
    }
}
